<template>
  <div class="flex flex-col gap-4 text-left" data-testid="invite-sent-step">
    <div class="flex items-start gap-3 bg-primary5 border border-primary/20 rounded-md px-4 py-3">
      <v-icon :icon="mdiCheckCircleOutline" color="primary" class="shrink-0 mt-0.5" />
      <div class="text-sm text-textPrimary">
        <p class="font-semibold">Convite enviado.</p>
        <p>
          A vaga continua aberta até o primeiro aceite.
          <span v-if="deadlineText">O convite vence em {{ deadlineText }}.</span>
        </p>
      </div>
    </div>

    <div>
      <p class="font-semibold text-textPrimary">Link do convite</p>
      <p class="text-sm text-[#68688D]">
        Cada médico tem um link próprio. Copie e envie pelo canal que você já usa com o médico.
      </p>
    </div>

    <ul class="list-none p-0 m-0 border border-gray-200 rounded-lg divide-y divide-gray-200">
      <li
        v-for="link in links"
        :key="link.inviteeId"
        class="flex flex-col md:flex-row md:items-center justify-between gap-3 px-4 py-3"
        data-testid="invite-link-row"
      >
        <div class="min-w-0">
          <p class="text-textPrimary truncate">{{ doctorName(link.doctorId) }}</p>
          <p class="text-xs text-[#68688D] break-all">{{ displayUrl(link.url) }}</p>
        </div>
        <OutlineButton
          height="40px"
          color="primary"
          :width="isDesktop ? '150px' : '100%'"
          class="shrink-0"
          data-testid="copy-invite-link-button"
          @click="copy(link.url)"
        >
          Copiar link
        </OutlineButton>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useToast } from 'vue-toastification'
import { mdiCheckCircleOutline } from '@mdi/js'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { useErrorToast } from '@/composables/useErrorToast'
import { DESKTOP_MEDIA_QUERY, useMediaQuery } from '@/hooks/useMediaQuery'
import type { CreatedAllocationInviteLink } from '@/Network/Types/Responses/AllocationInviteResponses'

defineProps<{
  links: CreatedAllocationInviteLink[]
  doctorName: (doctorId: number) => string
  /** `27/10 às 07:00` na hora da unidade; null sem vencimento conhecido. */
  deadlineText: string | null
}>()

const toast = useToast()
const { notifyErrorMessage } = useErrorToast()
// O OutlineButton fixa `width: 300px` inline no VBtn, que vence classes do Tailwind.
const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY)

/** Sem o protocolo, como no mockup. */
const displayUrl = (url: string) => url.replace(/^https?:\/\//, '')

// A cópia aqui não é auditada (plano WEB-1, P4): o link da criação é a única emissão.
async function copy(url: string) {
  try {
    await navigator.clipboard.writeText(url)
    toast.success('Link copiado.')
  } catch {
    notifyErrorMessage('Não foi possível copiar o link. Selecione e copie manualmente.')
  }
}
</script>
